import { render, staticRenderFns } from "./copyProjectTable.vue?vue&type=template&id=2306bb3a&scoped=true&"
import script from "./copyProjectTable.vue?vue&type=script&lang=js&"
export * from "./copyProjectTable.vue?vue&type=script&lang=js&"
import style0 from "./copyProjectTable.vue?vue&type=style&index=0&id=2306bb3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2306bb3a",
  null
  
)

export default component.exports